/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const RouterIpAddressContext = createContext({});
export default RouterIpAddressContext;
